import type { SVGProps } from 'react';
const SvgChevronUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5 15.088a.93.93 0 0 1 .256-.642l5.834-6.058a1.25 1.25 0 0 1 .417-.29q.237-.1.494-.098c.337-.008.664.123.91.364l5.834 6.057c.163.17.255.402.255.642a.93.93 0 0 1-.538.843.84.84 0 0 1-.954-.2l-5.507-5.695-5.508 5.718a.86.86 0 0 1-.618.271.84.84 0 0 1-.619-.27.88.88 0 0 1-.256-.642"
    />
  </svg>
);
export default SvgChevronUp;
